import React, { AnchorHTMLAttributes, InputHTMLAttributes } from 'react';
import { useHistory } from 'react-router';

export interface VoxelLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href?: string;
  openInNewTab?: boolean;
  className?: string;
  noUnderline?: boolean;
  openInNewIcon?: boolean;
}

export const VoxelLink: React.FC<VoxelLinkProps> = ({
  href,
  openInNewTab,
  onMouseDown,
  className,
  children,
  openInNewIcon,
  ...props
}) => {
  const history = useHistory();
  return (
    <a
      onMouseDown={onMouseDown}
      className={`cursor-pointer hover:underline hover: underline-offset-1 font-sans font-medium 
      ${className} whitespace-nowrap
      ${openInNewTab && openInNewIcon ? "after:content-['_↗']" : ''}
      
`}
      href={href}
      target={openInNewTab ? '_blank' : undefined}
      onClick={(event) => {
        event.stopPropagation();
        if (openInNewTab) return; // Let default browser take care of it
        event.preventDefault();
        history.push(href);
      }}
      {...props}
    >
      {children}{' '}
    </a>
  );
};

export default VoxelLink;
